import React from 'react';
import { Card, CardContent } from '../../../../../../../components/ui/card';

interface SoftwareVersionsProps {
    jobData: any;
}

const SoftwareVersions: React.FC<SoftwareVersionsProps> = ({ jobData }) => {
    const softwareVersions = jobData?.parsed_json_data?.['SOFTWARE VERSIONS']?.values?.[''] || {};

    const versionItems = [
        { key: 'application', label: 'Application Version' },
        { key: 'pendant', label: 'Pendant Version' },
        { key: 'torch', label: 'Torch Control Version' },
        { key: 'wirefeeder', label: 'Wire Feeder Version' },
        { key: 'travel', label: 'Travel Controller Version' },
        { key: 'psc', label: 'Power Supply Controller Version' }
    ];

    return (
        <div className="p-6 space-y-4">
            <Card className="bg-white border border-[#E2E5EA] shadow-sm">
                <CardContent className="p-5 w-full">
                    <h3 className="text-[14px] font-semibold text-blueprint-blue mb-4">Software Versions</h3>
                    <div className="grid grid-cols-2 md:grid-cols-3 gap-x-6 gap-y-4">
                        {versionItems.map((item) => {
                            const versionData = softwareVersions[item.key];
                            return (
                                <div key={item.key} className="min-w-0">
                                    <div className="text-[10px] font-bold uppercase tracking-wider text-heritage-grey mb-0.5">{versionData?.text || item.label}</div>
                                    <div className="text-[13px] font-medium text-text-grey">
                                        {versionData?.value || '-'}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </CardContent>
            </Card>
        </div>
    );
};

export default SoftwareVersions;

